import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Tooltip, Modal } from 'antd'
import moment from 'moment'
import { FaChevronDown, FaChevronUp, FaInfoCircle, FaPlane } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import OneWayFareCard from './OneWayFareCard'
import { useNavigate } from 'react-router-dom'

const RoundTripListInternationalCard = React.memo(({ item, flightInformation }) => {
    const roundCityLoading = useSelector((state) => state.flightRoundCity.filterLoading);
    const roundCityFlightFilterData = useSelector((state) => state.flightRoundCity.roundCityFlightFilterData);
    const [viewFare, setViewFare] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(true);
    const borderColor = item?.colorCode;
    const lowestPrice = Math.min(
        ...roundCityFlightFilterData?.results?.flights
            .map(item => item?.priceOptions?.[0]?.totalFare)
            .filter(price => price !== undefined)
    );


    const navigate = useNavigate();

    // const fetchFlightDetailTBO = (id) => {
    //     sessionStorage.setItem("comeFromReview", "true");
    //     navigate("/flight-review", { state: { traceId: item?.traceId, ResultIndex: item?.flightId, vendorType: item?.vendor } });
    // };

    // const fetchFlightDetailsTripjack = (id) => {
    //     sessionStorage.setItem("comeFromReview", "true");
    //     navigate("/flight-review", { state: { itemId: id, vendorType: item?.vendor } });
    // };


    // const handleMobileClick = () => {
    //     if (item?.vendor === "TripJack") {
    //         if (item?.priceOptions?.length > 1) {
    //             setViewFare(!viewFare);
    //         } else {
    //             fetchFlightDetailsTripjack(item?.priceOptions?.[0]?.id);
    //         }
    //     }

    //     if (item?.vendor === "TBO" && item?.priceOptions?.length === 1) {
    //         fetchFlightDetailTBO(item?.flightId);
    //     }

    //     setIsModalOpen(true);
    // };

    // const [isMobile, setIsMobile] = useState(false);

    // useEffect(() => {
    //     const checkIsMobile = () => {
    //         setIsMobile(window.innerWidth <= 768);
    //     };
    //     checkIsMobile();
    //     window.addEventListener('resize', checkIsMobile);
    //     return () => window.removeEventListener('resize', checkIsMobile);
    // }, []);


    const handleBookNow = () => {
        sessionStorage.setItem("comeFromReview", "true");
        if (item.vendor === "TripJack") {
            if (item.priceOptions?.length > 1) {
                setViewFare(!viewFare);
                return;
            }
            navigate("/flight-review", {
                state: { itemId: item?.priceOptions?.[0]?.id, vendorType: "TripJack" }
            });
            return;
        }

        if (item.vendor === "TBO") {
            navigate("/flight-review", {
                state: { traceId: item?.traceId, ResultIndex: item?.flightId, vendorType: "TBO" }
            });
        }
    };

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);


    const handleMobileClick = () => {
        sessionStorage.setItem("comeFromReview", "true");
        if (item.vendor === "TripJack") {
            if (item.priceOptions?.length > 1) {
                setIsModalOpen(true);
            } else {
                navigate("/flight-review", {
                    state: { itemId: item?.priceOptions?.[0]?.id, vendorType: "TripJack" }
                });
            }
            return;
        }
        if (item.vendor === "TBO") {
            if (item.priceOptions?.length > 1) {
                setIsModalOpen(true);
            } else {
                navigate("/flight-review", {
                    state: { traceId: item?.traceId, ResultIndex: item?.flightId, vendorType: "TBO" }
                });
            }
        }
    };

    return (
        <>
            <Card style={{ border: `1px solid ${borderColor}` }} loading={roundCityLoading} className={`card flights-list-item bg-white rounded-3 p-0 mb-1 international_card ${item?.priceOptions?.[0]?.totalFare === lowestPrice ? 'international_card_lowest single-minus' : ''}`}>
                <div onClick={() => (isMobile ? handleMobileClick() : handleBookNow())}>
                    {item?.priceOptions?.[0]?.totalFare === lowestPrice && (
                        <p className='lowest_price ' style={{ left: 'auto', borderTopRightRadius: '0' }}>Lowest Price</p>
                    )}
                    <Row gutter={20} className="gy-4 align-items-center justify-content-between">
                        <Col xl={18} flex="1 0 auto">
                            {/* onward Flight Details  */}
                            <Row gutter={20}>
                                <Col xl={24} xs={24}>
                                    <div className="d-flex align-items-center mb-xl-3 mb-2">
                                        <span className="label bg-light-primary text-primary me-2">Departure</span>
                                        <span className="text-muted text-sm">{moment(item?.departureTime).format('DD MMM YYYY')}</span>
                                    </div>
                                </Col>

                                <Col xl={24} xs={24}>
                                    <Row gutter={20} className="gx-lg-5 gx-3 gy-4 align-items-center flight-details-cntr">
                                        <Col md={7} xs={16} className='mb-2 mb-xl-0' style={{ order: '-1' }}>
                                            <div className="d-flex align-items-center justify-content-start">
                                                <div className="d-start fl-pic">
                                                    <img
                                                        className='img-collection result-flight'
                                                        src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${item?.flightCode}.gif`}
                                                        alt="logo"
                                                    />
                                                </div>
                                                <div className="d-end fl-title ps-2">
                                                    <Tooltip title={item?.airline}>
                                                        <div className="text-dark fw-medium">{item?.airline}</div>
                                                    </Tooltip>
                                                    <div className="text-sm text-muted">{item?.flightNumber}</div>
                                                </div>
                                            </div>
                                        </Col>

                                        <Col xs={24} md={13}>
                                            <Row gutter={16} className="row gx-3 align-items-center">
                                                <Col>
                                                    <div className="text-dark fw-bold">{moment(item?.departureTime).format('HH:mm')}</div>
                                                    <div className="text-muted text-sm fw-medium">{item?.origin}</div>
                                                </Col>

                                                <Col flex="auto" className="text-center">
                                                    <div className="flightLine departure">
                                                        <FaPlane className='flight-takeoff' />
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                    <div className="text-muted text-sm fw-medium mt-3">{item?.stops === 0 ? 'Direct' : `${item?.stops} stop${item?.stops > 1 ? 's' : ''}`} </div>
                                                </Col>

                                                <Col>
                                                    <div className="text-dark fw-bold">{moment(item?.arrivalTime).format('HH:mm')}</div>
                                                    <div className="text-muted text-sm fw-medium">{item?.destination}</div>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col md={4} xs={8} className='mb-2 mb-xl-0 text-end mobile-end-shift'>
                                            <div className="text-dark fw-medium">
                                                {/* {moment.duration(item?.duration, 'minutes').hours() + 'H' + moment.duration(item?.duration, 'minutes').minutes() + 'M'} */}
                                                {(() => {
                                                    if (!item?.total_duration) return "0H 0M"; // Handle undefined case
                                                    const duration = moment.duration(item.total_duration, 'minutes');
                                                    const totalHours = Math.floor(duration.asMinutes() / 60); // Correct total hours
                                                    return `${totalHours}H ${duration.minutes()}M`;
                                                })()}
                                            </div>
                                            <div className="text-muted text-sm fw-medium">{item?.stops} Stop</div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            {/* return  */}
                            <Row gutter={20} className="mt-3 mt-lg-4">
                                <Col xl={24} xs={24}>
                                    <div className="d-flex align-items-center mb-2 mb-xl-3">
                                        <span className="label bg-light-success text-success me-2">Return</span>
                                        <span className="text-muted text-sm">{moment(item?.returnDepartureTime).format('DD MMM YYYY')}</span>
                                    </div>
                                </Col>

                                <Col xl={24} xs={24}>
                                    <Row gutter={20} className="gx-lg-5 gx-3 gy-4 align-items-center flight-details-cntr">
                                        <Col md={7} xs={16} className='mb-2 mb-xl-0' style={{ order: '-1' }}>
                                            <div className="d-flex align-items-center justify-content-start">
                                                <div className="d-start fl-pic">
                                                    <img
                                                        className='img-collection result-flight'
                                                        src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${item?.returnFlightCode}.gif`}
                                                        alt="logo"
                                                    />
                                                </div>
                                                <div className="d-end fl-title ps-2">
                                                    <Tooltip title={item?.returnAirline}>
                                                        <div className="text-dark fw-medium">{item?.returnAirline}</div>
                                                    </Tooltip>
                                                    <div className="text-sm text-muted">{item?.returnFlightNumber}</div>
                                                </div>
                                            </div>
                                        </Col>

                                        <Col xs={24} md={13}>
                                            <Row gutter={16} className="row gx-3 align-items-center">
                                                <Col>
                                                    <div className="text-dark fw-bold">{moment(item?.returnDepartureTime).format('HH:mm')}</div>
                                                    <div className="text-muted text-sm fw-medium">{item?.returnOrigin}</div>
                                                </Col>

                                                <Col flex="auto" className="text-center">
                                                    <div className="flightLine departure">
                                                        <FaPlane className='flight-takeoff' />
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                    <div className="text-muted text-sm fw-medium mt-3">{item?.returnStops === 0 ? 'Direct' : `${item?.returnStops} stop${item?.returnStops > 1 ? 's' : ''}`}</div>
                                                </Col>

                                                <Col>
                                                    <div className="text-dark fw-bold">{moment(item?.returnArrivalTime).format('HH:mm')}</div>
                                                    <div className="text-muted text-sm fw-medium">{item?.returnDestination}</div>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col md={4} xs={8} className='mb-2 mb-xl-0 text-end mobile-end-shift'>
                                            <div className="text-dark fw-medium">
                                                {/* {moment.duration(item?.return_total_duration, 'minutes').hours() + 'H' + moment.duration(item?.return_total_duration, 'minutes').minutes() + 'M'} */}
                                                {(() => {
                                                    if (!item?.return_total_duration) return "0H 0M";
                                                    const duration = moment.duration(item.return_total_duration, 'minutes');
                                                    const totalHours = Math.floor(duration.asMinutes() / 60);
                                                    return `${totalHours}H ${duration.minutes()}M`
                                                })()}
                                            </div>
                                            <div className="text-muted text-sm fw-medium">{item?.returnStops} Stop</div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>

                        <Col xl={6} xs={24} className='mt-2 mt-xl-0 international_price'>
                            <div className="d-xl-flex items-center justify-content-between w-100 h-100">
                                <div className="d-xl-block d-none border br-dashed me-4"></div>
                                <div className="d-block d-xl-none border-top br-dashed mb-3"></div>
                                <div className=''>

                                    <div className='d-flex flex-wrap d-xl-block justify-content-between align-items-center xlMargin'>
                                        <div className="text-start text-xl-end mb-xl-1">
                                            <div className="text-dark fs-3 fw-bold lh-sm text-primary">
                                                ₹{item?.priceOptions?.[0]?.totalFare.toLocaleString()}</div>
                                        </div>
                                        <div className="flight-button-wrap d-flex justify-content-end">
                                            {item?.vendor === "TripJack" && (
                                                item?.priceOptions?.length > 1 ? (
                                                    <button
                                                        className='btn btn-primary menu-block outline-none d-none d-md-inline-flex align-items-center gap-1'
                                                        type="primary"
                                                        onClick={() => setViewFare(!viewFare)}
                                                        aria-label="Book Now"
                                                    >
                                                        {viewFare ? (
                                                            <>
                                                                Book Now <FaChevronUp />
                                                            </>
                                                        ) : (
                                                            <>
                                                                Book Now <FaChevronDown />
                                                            </>
                                                        )}
                                                    </button>
                                                ) : (
                                                    <button
                                                        className='btn btn-primary menu-block outline-none d-none d-md-block'
                                                        type="primary"
                                                        aria-label="Flight Details Tripjack"
                                                    >
                                                        Book Now
                                                    </button>
                                                )
                                            )}

                                            {item?.vendor === "TBO" && (
                                                item?.priceOptions?.length === 1 && (
                                                    <button
                                                        className='btn btn-primary menu-block outline-none d-none d-md-block'
                                                        type="primary"
                                                        aria-label="flight details TBO"
                                                    >
                                                        Book Now
                                                    </button>
                                                )
                                            )}

                                            <button type="primary" onClick={() => setIsModalOpen(true)} className='btn btn-primary menu-block outline-none d-md-none' aria-label="Book now">
                                                Book Now
                                            </button>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Col>

                        <Col xl={18} xs={24} className='text-center mt-xl-2'>
                            {item?.priceOptions?.[0]?.coupon_discount &&
                                <Row gutter={16} className='mt-1 text-center'>
                                    <Col xs={24} className='text-center'>
                                        <span className='d-flex align-items-center gap-1 justify-content-center w-100 text-sm text-primary fw-bold  rounded' style={{ padding: '1px 0' }}>
                                            <svg style={{ fill: 'var(--primary-color)' }} width="1.2em" height="1.2em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m20.749 12 1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a.998.998 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104 1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367L20.749 12zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001zm.3 9.6-1.6-1.199 6-8 1.6 1.199-6 8zm4.7.4a1.5 1.5 0 1 1 .001-3.001 1.5 1.5 0 0 1-.001 3.001z"></path></g></svg>
                                            {item?.priceOptions?.[0]?.coupon_discount}
                                        </span>
                                    </Col>
                                </Row>
                            }
                        </Col>
                    </Row>

                    {viewFare &&
                        <>
                            <div className='fare-cntr border-top pt-3 d-none d-md-flex'>
                                {item?.priceOptions?.map((flight, index) => (
                                    <OneWayFareCard key={index} item={item} flightData={flight} />
                                ))}
                            </div>
                        </>
                    }
                </div>


                <button onClick={() => flightInformation(item)} className='tabs-popup-btn fw-bold text-center text-xl-end float-xl-end d-none d-md-flex align-items-center height-26 top-10 mt-2 mt-xl-0' aria-label="flight details">
                    <FaInfoCircle className='me-1' /> Flight Details
                </button>
            </Card>



            <Modal title="Fare" open={isModalOpen} onOk={() => setIsModalOpen(false)} onCancel={() => setIsModalOpen(false)} className='farePopup d-md-none'>
                <div className='fare-cntr'>
                    {item?.priceOptions.map((flight, index) => (
                        <OneWayFareCard index={index} key={index} flightData={flight} item={item} />
                    ))}
                </div>
            </Modal>

        </>
    )
});

export default RoundTripListInternationalCard;